import React from 'react';
import InstructionBuilder from './InstructionBuilder';
import BuyInstructionContent from './content/BuyInstructionContent';

const BankInstructions = ({ account }) => {
  const { accountName, sweepAccount } = account;
  const content = BuyInstructionContent(accountName);
  return <InstructionBuilder content={content} isSweepAccount={sweepAccount}/>;
};

export default BankInstructions;
